import React from 'react';
import { getCreatividadLabels } from '../../utils/creatividadesLabels';
import styles from '../../styles/creatividadNombre.module.css';

const CreatividadNombre = ({ creatividad, variant = 'card' }) => {
  const { nombreNuevo, nombreAntiguo } = getCreatividadLabels(creatividad);
  const nameClass = variant === 'hero' ? styles.heroName : styles.cardName;

  return (
    <div className={styles.block}>
      <span className={nameClass}>{nombreNuevo}</span>
      {nombreAntiguo ? (
        <span className={styles.nombreAntiguo}>{nombreAntiguo}</span>
      ) : null}
    </div>
  );
};

export default CreatividadNombre;
